import request from '@/utils/request'
export function realtimeData(locationId){
  return request({
    url: `${window.g.deviceServe}/api/location/${locationId}/1/realtime-data.json`,
    method: 'get',
  })
}

export function historyData(data){
  return request({
    url: `${window.g.deviceServe}/api/sites/historyData`,
    method: 'get',
    params:data
  })
}

export function relicList(locationId){
  return request({
    url: `/shanDongScreen/relics/${locationId}`,
    method: 'get',
  })
}


